export { default } from "./algolia-autocomplete-search";
